import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import { endpoints } from "../../services/apiurl";
import Card from "@mui/material/Card";
import PageTitle from "../UI/PageTitle";
import { Visibility } from "@mui/icons-material";
import { InfinitySpin } from "react-loader-spinner";

const RestDish = () => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
    fetchData(1, perPage);
  }, [perPage]);

  // console.log(localStorage.getItem('user'));
  let a = localStorage.getItem("user");
  let b = JSON.parse(a);
  let rest_id = b.restro_id;

  const columns = [
    {
      name: "NAME",
      selector: (row) => row.name,
      // width: '200px'
    },
    {
      name: "ACTION",
      cell: (row) => (
        <div>
          <Link variant="contained" to={`/dashboard/topdishes/${row.id}`}>
            <Visibility />
          </Link>
        </div>
      ),
      selector: (row) => row.id,
      // width: '200px'
    },
  ];

  const fetchData = async (page, per_page) => {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;

    await axios
      .post(endpoints.getRestaurentsInApp, {
        page,
        per_page,
        user_id,
        restro_id,
      })
      .then(
        (response) => {
          //  console.log(response.data.data)
          setIsLoaded(true);
          setItems(response.data.data);
          setTotalRows(response.data.total);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const handlePageChange = (page) => {
    fetchData(page, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className="spinner">
        <InfinitySpin
          visible={true}
          width="200"
          color="#fbaa1a"
          ariaLabel="infinity-spin-loading"
        />
      </div>
    );
  } else {
    return (
      <div className="App">
        {rest_id === 0 ? (
          <PageTitle
            title="Restaurants List"
            linkurl="/dashboard/addrestaurents"
            linkTitle="Add Restaurants"
          />
        ) : (
          ""
        )}

        <Card className="px-3 py-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default RestDish;
